import Icon from '../components/Icon.vue'

Icon.register({"chalkboard":{"width":640,"height":512,"paths":[{"d":"M96 64H544V416H608V40C608 17.9 590.1 0 568 0H72C49.9 0 32 17.9 32 40V416H96V64zM624 448H480V384H288V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chalkboard.js
// module id = ZDBp
// module chunks = 0